import React, { useEffect } from 'react'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { UPDATE_EMPLOYEE_LABELS, UPDATE_EMPLOYEE_NAMES, ADD_EMPLOYEE_PLACEHOLDER } from '../../constants/employeeData'
import { employeeDataApi } from '../../services'
import { EmployeeDataHoc } from '../../utils/hocs'
import { RadioGroup, Input, SingleSelectInput } from '../common/atoms'
import { successOrFailureToaster } from '../common/atoms/messages'
import { DatePicker } from '../tailwind/molecules'
import { ALL_COUNTRIES_ISD_CODES, SALES_ROLE } from '../../constants/overview'
import Dropdown from '../common/atoms/Dropdown'
import { dropdownDownArrow } from '../../assets/images'
import { dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles';


const AddEmployee = () => {
  const [state, setState] = useState({first_name : '', last_name : '', mobile_number : '', email : '', employee_id : '', sponsor_department : '', sponsor_location : '', vip : false, gender : '', date_of_birth : '', entity_name : '',isd_code :'+91'})
  const [error , setError] =  useState({})
  const [entities, setEntities] = useState([])
  const [grades, setGrades] = useState([])
  let history = useHistory()
  const [openDropdown, updateOpenDropdown] = useState(false)
  const allCountryIsdCode = ALL_COUNTRIES_ISD_CODES.map(code => ({...code, disabled: ( code.id !== state.isd_code ) }))

  const setSubState =(newState) =>{
    setState(prevState => {return {...prevState , ...newState}})
  }


  const fetchEntityDetails = () => {
    employeeDataApi.fetch_entity_details(
      { id: state.sponsor },
      (res) => {
        const data = res.data.entities || []
        setEntities(data)
      },
      (err) => handleAppError(err)
    )
  }

  const fetchGradesDetails = () => {
    employeeDataApi.company_grades(
      { companyId: state.sponsor },
      (res) => {
        let data = res.data.grades || []
        data.push('UNGRADED').uniq
        setGrades(data)
      },
      (err) => handleAppError(err)
    )
  }  

  useEffect(() => {
  fetchEntityDetails()
  fetchGradesDetails()
  }, [])
  
  const validateData = (data) => {
    const emailRegExp = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}\b/i
    let newErrors = {}
    if(!data.first_name)  newErrors = {...newErrors , first_name :  'Field is mandatory'}
    else if (!data.email) newErrors = {...newErrors , email :  'Field is mandatory'}
    else if (!data.email.match(emailRegExp))   newErrors = {...newErrors , email :  'Invalid mail'}
    else if (!data.gender) newErrors = {...newErrors , gender :  'Field is mandatory'}
    else if (!data.entity_name && entityNames.length > 0) newErrors = {...newErrors , entity_name :  'Field is mandatory'}
    setError(newErrors)
    return Object.keys(newErrors || {}).length === 0
  }

  const onSave = async () => {
    let condition = validateData(state)
    if(condition){
      const options = { data : state }
      await employeeDataApi.add_employee(
        options,
        (res) => {
          let data = res.data
          successOrFailureToaster({message : 'Employee registered successfully'})
          history.push('/manage-employee')
        },
        (err) => {
          let getError ={ email : 'email address', employee_id : 'employee id', mobile_number : 'mobile number', alternative_mobile_number: 'mobile number'}
          let res = getError[Object.keys(err.response.data.msg)[0]] 
          successOrFailureToaster({message : `User is already registered with this ${res}`, type : 'fail'}) 
        }
      )
    }
  }

  const formHandler = (event) => {
    let name = '' , value =''
    if(['date_of_birth', 'entity_name', 'grade','isd_code'].includes(event.name)) {
      name = event.name
      value = event.value
    }
    else {
      name = event.target.name
      value = event.target.value
    }
    var letters = /^[a-zA-Z\s]*$/;
    if(name === 'first_name' || name === 'last_name' ){
      if(!value.match(letters)) return false
      else value = (value === ' ' ? value.trim() : value)
    }
    if(name === 'email') value = (value === ' ' ? value.trim() : value)
    if(name === 'vip') value = value === 'Yes'

    if(name == 'entity_name'){
      const entityValue = entities.find((option) => option.name === value)?.id
      setSubState({...state, entity_id: entityValue, [name]: value }) 
    }else{
      setSubState({...state, [name]: value })
    }
    setError('')
  }
  
  const entityNames = entities.map((item) => item.name)

  return (
    <React.Fragment>
    <EmployeeDataHoc
      classes='pb-32'
      title='Add employee'
      breadcrumb={[{ text: 'Manage employees', link: '/manage-employee' },{ text: 'Add employee', link: '#' }]}
      close={() => history.goBack()}
    >
      <h1 className='text-sm font-semibold tracking-widest leading-3 text-gray-500 mt-6 mb-3'>EMPLOYEE DETAILS</h1>
      <div className='bg-white rounded-md border'>
        <div className='grid grid-cols-3 gap-x-4 gap-y-6 p-6'>
          {UPDATE_EMPLOYEE_NAMES.map((item, ind) => {
            const label = UPDATE_EMPLOYEE_LABELS[ind]
            const placeholder = ADD_EMPLOYEE_PLACEHOLDER[ind]
            return ( 
            <div>
            {item === 'date_of_birth' ?
            <DatePicker
              labelClasses='font-semibold tracking-widest leading-3 mb-3'
              label={label}
              value = {state[item]}
              inputClasses='text-gray-700 border -pb-2 bg-gray-100 font-semibold text-base leading-4 w-full'
              classes ='mt-4'
              color='#6B7280'
              size='12px'
              handler={(value) => {
                let name='date_of_birth'
                formHandler({name, value})
              }} 
              height='46px'
            />
            : item === 'mobile_number' ?
            <div className='flex justify-start'>
            <Dropdown onChange={(item) => {
                const value= item.id
                let name='isd_code'
                formHandler({name, value})
                updateOpenDropdown(false)
              }} 
              selectedItem={state.isd_code} toggleList={()=>updateOpenDropdown(!openDropdown)} listOpen={openDropdown} 
              list={allCountryIsdCode} title={state.isd_code} padding={"12px 8px 12px 10px"} 
              dropDownIcon={dropdownDownArrow} mr={'2'} fontSize={'14px'} closeOnClickOverlay={true}
              marginTopOptions={'6'} borderRequired={true} isdisable={state.benefitAvailed }
            />
             <Input key={ind} placeholder={placeholder} inputClasses='text-gray-700 placeholder-gray-275 text-base h-12' labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3' value={state[item]} name={item} label={label} type={item === 'mobile_number' ? 'number' : 'text'} handler={formHandler} error={error[item]} />
            
           </div>
            :
            <Input key={ind} placeholder={placeholder} inputClasses='text-gray-700 placeholder-gray-275 text-base h-12' labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3' value={state[item]} name={item} label={label} type={item === 'mobile_number' ? 'number' : 'text'} handler={formHandler} error={error[item]} />
            }
            </div>
            )
          })}
          { entityNames.length > 0 ? 
            <SingleSelectInput 
              onChangeHandler={formHandler}  
              value={state.entity_name}
              data={entityNames}
              search={true}
              name='entity_name'
              placeholder='Select' 
              label='ENTITY NAME' 
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize p-6 pb-5'
              bgColor='bg-gray-100 capitalize'
              disable={SALES_ROLE === "sales"}
              placeholderClasses='h-4'
              error={error['entity_name']}
            />
            : null
          }
          <SingleSelectInput 
            onChangeHandler={formHandler}  
            value={state.grade || 'UNGRADED'}
            data={grades}
            name='grade'
            placeholder='Select' 
            label='GRADE' 
            labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
            listClasses='z-20'
            listItemClasses='capitalize p-6 pb-5'
            bgColor='bg-gray-100 capitalize'
            disable={grades.length == 0}
            placeholderClasses='h-4'
          />
        </div>
        
        <div className='p-6 pt-0 grid grid-cols-3 gap-x-4 gap-y-6'>
          <RadioGroup title='GENDER' radioList={['Male', 'Female', 'Non-binary']} titleClasses='text-xs mb-3 font-semibold tracking-widest leading-3 text-gray-500 mb-3' radioInputClasses='h-5 w-5 focus:ring-0 focus:ring-white' labelClases='text-gray-700 text-base leading-4 ml-3 font-semibold font-proxima-nova' radioClasses='grid-cols-3' name='gender' value={state.gender} handler={formHandler} error={error.gender} />
          <RadioGroup title='VIP CUSTOMER' radioList={['Yes', 'No']} titleClasses='text-xs mb-3 font-semibold tracking-widest leading-3 text-gray-500 mb-3' radioInputClasses='h-5 w-5 focus:ring-0 focus:ring-white' labelClases='text-gray-700 text-base leading-4 ml-3 font-semibold font-proxima-nova'  name='vip' value={state.vip ? 'Yes' : 'No' } handler={formHandler} />
        </div>
       

        <div className='p-4 text-right border' style={{backgroundColor : '#EFF6FF'}}>
          <button className={joinButtonClasses(dsButtonSecondary, 'h-11 px-6')} onClick={() => history.goBack()}>
            Cancel
          </button>
          <button type='submit' disabled={SALES_ROLE === "sales"} className={joinButtonClasses(dsButtonPrimary, 'ml-3 h-11 px-6')} onClick={onSave}>
            Save
          </button>
        </div>
      </div>
    </EmployeeDataHoc>
    </React.Fragment>
  )  
}

export default AddEmployee
